import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface SkeletonCardProps {
  className?: string;
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({ className = "" }) => {
  const { theme } = useTheme();
  return (
    <div className={`relative w-full aspect-[3/4] ${theme === 'dark' ? 'bg-zinc-700' : 'bg-theme-tertiary'} rounded-lg theme-light:border-2 theme-light:border-theme-primary overflow-hidden animate-pulse ${className}`}>
    </div>
  );
};

export default SkeletonCard;
